import { AbstractService } from "./abstract.service";

export class DiliveryServices extends AbstractService {

  static get entity() {
    return "n360/inte/api/integrate"
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getListDilivery(type) {
    try {
      const response = await this.callApi().get(
        `${this.entity}/app/get-apps-with-integrate-info-by-category/${type}`
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async checkPackageDilivery(params, partnerCode) {
    const response = await this.callApi().post(
      `${this.entity}/delivery/calculate-shipping-money/${partnerCode}`,
      params
    )
    return response.data;
  }
}
